import React, { useState } from "react";
import {
  Box,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Fade,
  Backdrop,
} from "@mui/material";
import { X, Upload, Check, AlertCircle } from "lucide-react";

const modalStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70vw",
  height: "80vh",
  bgcolor: "#ffffff",
  boxShadow: 24,
  p: 3,
  overflow: "scroll",
};

const Fieldscommonmodal = ({
  open,
  onClose,
  textfields,
  UpdateVehicleDetails,
  form,
  handleChange,
  setForm,
  selectedRow,
  error,
  affectedBookings,
  blockedVehciles,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const vehicleBlockType = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.vehicleBlockType;

  const generateTimeOptions = (step = 30) => {
    const times = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += step) {
        const hh = String(h).padStart(2, "0");
        const mm = String(m).padStart(2, "0");
        times.push(`${hh}:${mm}`);
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions(30);
  const today = new Date().toISOString().split("T")[0];

  const getDateMin = (field) => {
    if (field.type !== "date") return undefined;
    if (field.value === "startdate" || field.value === "startDate") return today;
    if (field.value === "enddate" || field.value === "endDate") return form?.startdate || today;
    return undefined;
  };

  return (
    <Modal
      open={!!open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
          sx: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
        },
      }}
    >
      <Fade in={!!open}>
        <Box sx={modalStyle}>
          {/* Header */}
          <div className="sticky top-0 z-10 bg-blue-600 px-8 py-3 border-b border-blue-700">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-xl font-bold text-white">Edit Details</h1>
                {/* <p className="text-indigo-100 text-sm mt-1">
                  Update vehicle information
                </p> */}
              </div>
              <button
                onClick={onClose}
                className="text-white hover:bg-white/20 p-2 rounded-full transition-all duration-200 hover:rotate-90"
                aria-label="Close modal"
              >
                <X size={24} />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto px-8 py-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {textfields.map((field, index) => (
                <div key={index} className="group">
                  <label className="block mb-2 font-semibold text-gray-700 text-sm">
                    {field.label}
                    {field.required && (
                      <span className="text-red-500 ml-1">*</span>
                    )}
                  </label>

                  {field.type === "dropdown" ? (
                    <FormControl
                      fullWidth
                      size="small"
                      className="transition-all duration-200 hover:shadow-md"
                    >
                      <InputLabel id={`drop-label-${index}`}>
                        {field?.label}
                      </InputLabel>
                      <Select
                        labelId={`drop-label-${index}`}
                        value={form[field.value] || ""}
                        onChange={(e) =>
                          handleChange(field.value, e.target.value)
                        }
                        label={field?.label}
                        sx={{
                          borderRadius: "8px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e5e7eb",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#818cf8",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6366f1",
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              maxHeight: 240,
                              borderRadius: "8px",
                              boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                            },
                          },
                        }}
                      >
                        {field?.subCategory
                          ?.filter((opt) => opt.item !== "inverted") // optional safety
                          .map((option, idx) => (
                            <MenuItem
                              key={idx}
                              value={option.item} // API value
                              sx={{
                                fontSize: "0.875rem",
                                "&:hover": {
                                  backgroundColor: "#eef2ff",
                                },
                              }}
                            >
                              {option.value} {/* UI label */}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  ) : field.type === "file" ? (
                    <div className="space-y-3">
                      <div className="relative">
                        <input
                          disabled={field.disabled}
                          type="file"
                          id={`file-${index}`}
                          onChange={(e) =>
                            handleChange(field.value, e.target.files[0])
                          }
                          className="hidden"
                          accept="image/*"
                        />
                        <label
                          htmlFor={`file-${index}`}
                          className={`flex items-center justify-center gap-2 w-full border-2 border-dashed rounded-lg p-4 transition-all duration-200 ${
                            field.disabled
                              ? "bg-gray-100 cursor-not-allowed"
                              : "border-indigo-300 hover:border-indigo-500 hover:bg-indigo-50 cursor-pointer"
                          }`}
                        >
                          <Upload size={20} className="text-indigo-600" />
                          <span className="text-sm text-gray-600">
                            {form[field.value] ? "Change file" : "Upload file"}
                          </span>
                        </label>
                      </div>
                      {form[field.value] && (
                        <div className="relative rounded-lg overflow-hidden shadow-md border-2 border-gray-200">
                          <img
                            src={
                              form[field.value].Location ||
                              form[field.value].path ||
                              form[field.value].url
                            }
                            className="w-full h-32 object-cover"
                            alt="Preview"
                          />
                          <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                            <Check size={16} />
                          </div>
                        </div>
                      )}
                    </div>
                  ) : field.type === "time" ? (
                    <select
                      disabled={field.disabled}
                      value={form[field.value] || ""}
                      onChange={(e) => {
                        handleChange(field.value, e.target.value);
                      }}
                      className={`w-full border rounded-lg px-4 py-2.5 text-sm transition-all duration-200 ${
                        field.disabled
                          ? "bg-gray-100 cursor-not-allowed"
                          : "border-gray-300 hover:border-indigo-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                      } outline-none`}
                    >
                      <option value="">Select {field.label}</option>

                      {timeOptions.map((time) => (
                        <option key={time} value={time}>
                          {time}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      disabled={field.disabled}
                      type={field.type}
                      value={form[field.value] || ""}
                      min={getDateMin(field)}
                      onChange={(e) =>
                        handleChange(field.value, e.target.value)
                      }
                      className={`w-full border rounded-lg px-4 py-2.5 text-sm transition-all duration-200 ${
                        field.disabled
                          ? "bg-gray-100 cursor-not-allowed"
                          : "border-gray-300 hover:border-indigo-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                      } outline-none`}
                      placeholder={`Enter ${field.label.toLowerCase()}`}
                    />
                  )}
                </div>
              ))}
            </div>

            {affectedBookings && (
              <>
                <div className="mt-12 p-4">
                  <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                    Affected Bookings
                  </h2>

                  <div className="overflow-auto rounded-lg shadow bg-white">
                    <table className="min-w-full text-sm text-left shadow-lg border border-gray-100">
                      <thead className="">
                        <tr>
                          <th className="p-4">ID</th>
                          <th className="p-4">Booking Code</th>
                          <th className="p-4">Book From</th>
                          <th className="p-4">Book To</th>
                          <th className="p-4">Status</th>
                          <th className="p-4 text-right">Ticket Size</th>
                        </tr>
                      </thead>
                      <tbody>
                        {affectedBookings.length ? (
                          affectedBookings.map((data) => (
                            <tr
                              key={data?.id}
                              className="border-b hover:bg-gray-50"
                            >
                              <td className="p-4">{data?.id}</td>
                              <td className="p-4">{data?.bookingCode}</td>
                              <td className="p-4">{data?.bookFrom}</td>
                              <td className="p-4">{data?.bookTo}</td>
                              <td className="p-4">
                                {fleetBookingStatus[data?.bookingStatus]}
                              </td>
                              <td className="p-4 text-right">
                                {data?.costToCustomer}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="6"
                              className="text-center p-4 text-gray-500"
                            >
                              No affected bookings found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}

            {blockedVehciles && (
              <>
                <div className="mt-12 p-4">
                  <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                    Blocked List
                  </h2>

                  <div className="overflow-auto rounded-lg shadow bg-white">
                    <table className="min-w-full text-sm text-left shadow-lg border border-gray-100">
                      <thead className="">
                        <tr>
                          <th className="p-4">Start Date</th>
                          <th className="p-4">End Date</th>
                          <th className="p-4">Block Type</th>
                          <th className="p-4 text-right">Blocked By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {blockedVehciles.length ? (
                          blockedVehciles.map((data) => (
                            <tr
                              key={data?.id}
                              className="border-b hover:bg-gray-50"
                            >
                              <td className="p-4">{data?.startDate}</td>
                              <td className="p-4">{data?.endDate}</td>
                              <td className="p-4">
                                {vehicleBlockType[data?.blockType]}
                              </td>
                              <td className="p-4 text-right">
                                {data?.blockedBy}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="6"
                              className="text-center p-4 text-gray-500"
                            >
                              No affected bookings found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}

            {/* Error Message */}
            {error && (
              <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-3">
                <AlertCircle
                  className="text-red-500 flex-shrink-0 mt-0.5"
                  size={20}
                />
                <p className="text-red-700 text-sm">{error}</p>
              </div>
            )}

            {/* Success Message */}
            {successMessage && (
              <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-start gap-3">
                <Check
                  className="text-green-500 flex-shrink-0 mt-0.5"
                  size={20}
                />
                <p className="text-green-700 text-sm">{successMessage}</p>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="bottom-0 bg-white px-8 py-5 border-t border-gray-200">
            <div className="flex justify-end gap-4">
              <button
                onClick={onClose}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 transition-colors duration-200"
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                onClick={UpdateVehicleDetails}
                disabled={isSubmitting}
                className="relative px-8 py-2.5 rounded-lg bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none overflow-hidden group"
              >
                <span
                  className={`flex items-center gap-2 ${
                    isSubmitting ? "opacity-0" : ""
                  }`}
                >
                  <Check size={18} />
                  Update Details
                </span>
                {isSubmitting && (
                  <span className="absolute inset-0 flex items-center justify-center">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  </span>
                )}
              </button>
            </div>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

export default Fieldscommonmodal;
